import React from "react"
import { formatCruiseArrivalDepartureDate, toUTCDate } from "../app-core/_common/format/date"
import ErrorBoundaryInline from "./ErrorBoundaryInline"

interface CruiseDepartureArrivalDatesProps {
    departureDate: string | Date | undefined
    arrivalDate: string | Date | undefined
}

const CruiseDepartureArrivalDates: React.FC<React.PropsWithChildren<CruiseDepartureArrivalDatesProps>> = ({
    departureDate: departureDateString,
    arrivalDate: arrivalDateString,
}) => {
    if (!departureDateString || !arrivalDateString) return null

    const departureDate = toUTCDate(departureDateString)
    const arrivalDate = toUTCDate(arrivalDateString)
    const formattedValue = formatCruiseArrivalDepartureDate(departureDate, arrivalDate)

    return <React.Fragment>{formattedValue}</React.Fragment>
}

const SafeCruiseDepartureArrivalDates: React.FC<React.PropsWithChildren<CruiseDepartureArrivalDatesProps>> = (
    props,
) => {
    return (
        <ErrorBoundaryInline sendToRollbar>
            <CruiseDepartureArrivalDates {...props} />
        </ErrorBoundaryInline>
    )
}

const CruiseDepartureArrivalDatesMemo = React.memo(
    SafeCruiseDepartureArrivalDates,
    (prevProps, nextProps) =>
        prevProps.departureDate == nextProps.departureDate && prevProps.arrivalDate == nextProps.arrivalDate,
)
CruiseDepartureArrivalDatesMemo.displayName = "CruiseDepartureArrivalDatesMemo"
export default CruiseDepartureArrivalDatesMemo
